<template>
  <layout-basic>
    <v-container fluid>
      <v-row>
        <v-col class="Full-Course-Library-Title"> Playlists </v-col>
      </v-row>
      <v-row class="sm-mt-20">
        <v-col cols="12" sm="4">
          <v-text-field
                class="search-box"
                placeholder="Search Playlists"
                prepend-icon="fa-search"
                v-model="search"
                type="text"
                clearable
                clear-icon="fa-times"
                @click:clear="resetSearch"
                @change="applySearch"
              ></v-text-field>
        </v-col>
        <v-col cols="12" sm="7" class="sm-mt-10">
          <v-btn
            color="primary"
            outlined
            @click.prevent="showCreatePanel"
            class="add-course-button"
          >
            Add New Playlist
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="channels"
              :footer-props="{
                'items-per-page-options': [5, 10, 15],
              }"
            >
              <template v-slot:item.published="{ item }">
                <v-icon v-if="item.published" color="green">fa-check</v-icon>
                <v-icon v-else color="red">fa-times</v-icon>
              </template>
              <template v-slot:item.icon="{ item }">
                <i v-if="item.icon" class="fa" :class="'fa-' + item.icon"></i>
                <table-thumb v-if="item.thumbnail" :thumb="item"></table-thumb>
              </template>
              <template v-slot:item.id="{ item }">
                <v-select
                  v-if="screenSize === 'tablet' || screenSize === 'mobile'"
                  v-model="selectedAction"
                  :items="getActionList(item)"
                  item-text="name"
                  item-value="id"
                  placeholder="Select Action"
                  @change="performAction(item)"
                ></v-select>
                <template v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="mr-1 action-button action-button-txt"
                        outlined
                        small
                        @click.prevent="showEditPanel(item.id)"
                      >
                        Edit
                      </v-btn>
                    </template>
                    <span>Edit Playlist</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        outlined
                        class="mr-1 action-button action-button-txt"
                        small
                        @click.prevent="showEnrolPanel(item.id)"
                      >
                        Enrol
                      </v-btn>
                    </template>
                    <span>Enrol users/groups onto this playlist</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        outlined
                        class="mr-1 action-button action-button-txt"
                        small
                        @click.prevent="showUnEnrolPanel(item.id)"
                      >
                        Unenroll
                      </v-btn>
                    </template>
                    <span>Unenroll users/groups onto this playlist</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="mr-1 action-button action-button-txt"
                        outlined
                        small
                        @click.prevent="showModulesPanel(item.id)"
                      >
                        Courses
                      </v-btn>
                    </template>
                    <span>Assign Courses</span>
                  </v-tooltip>
                  <!--<v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                        v-if="item.total_modules > 0"
                                        v-on="on"
                                        small
                                        :to="'/admin/playlists/organise/' + item.id"
                                        color="primary"
                                        class="mr-1 action-button action-button-txt"
                                        outlined
                                        >
                                            Manage Courses
                                        </v-btn>
                                        <v-btn
                                        v-else
                                        disabled
                                        v-on="on"
                                        small
                                        :to="'/admin/playlists/organise/' + item.id"
                                        color="primary"
                                        class="mr-1 action-button action-button-txt"
                                        outlined
                                        >
                                            Manage Courses
                                        </v-btn>
                                    </template>
                                    <span>Manage Courses</span>
                                </v-tooltip>-->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="ml-1 action-button action-button-txt"
                        outlined
                        small
                        @click.prevent="showSuppMaterialsPanel(item.id)"
                      >
                        Content
                      </v-btn>
                    </template>
                    <span>Additional Content</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="ml-1 Frame-61"
                        text
                        x-small
                        color="$improve-grey-900"
                        @click.prevent="deleteChannel(item.id)"
                      >
                        <v-icon small>fa fa-trash</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete Playlist</span>
                  </v-tooltip>
                </template>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import channelAPI from '@/api/channel.js';
import LayoutBasic from '@/layouts/Dashboard';
import CreateChannel from '@/components/admin/channels/Create';
import EditChannel from '@/components/admin/channels/Edit';
import EnrolUsers from '@/components/admin/channels/Enrol';
import UnEnrolUsers from '@/components/admin/channels/UnEnrol';
import ChannelContent from '@/components/admin/channels/Content';
import Modules from '@/components/admin/channels/AddModules';
import SuppMaterials from '@/components/admin/channels/Assets';
import TableThumb from '@/components/admin/channels/TableThumb';
import companyAPI from '@/api/company.js';
import { screensize } from '../../utils/screensize';

// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();

export default {
  name: 'ChannelsAdmin',
  components: {
    LayoutBasic,
    TableThumb,
  },
  data() {
    return {
      headers: [
        {
          text: 'Icon / Thumbnail',
          value: 'icon',
          sortable: false,
          align: 'center',
        },
        { text: 'Playlist', value: 'name' },
        /*{ text: "Assigned Users", value: "individual_users", sortable: false },
                    { text: "Assigned Groups", value: "total_groups", sortable: false },
                    { text: "Total Users", value: "total_users", sortable: false },
                    { text: "Modules", value: "total_modules", sortable: false },
                    { text: "Levels", value: "levels", sortable: false },*/
        { text: '', value: 'id', sortable: false, align: 'end' },
      ],
      actions: [
        { id: 1, name: 'Edit' },
        { id: 2, name: 'Enrol' },
        { id: 3, name: 'Unenroll' },
        { id: 4, name: 'Courses' },
        { id: 5, name: 'Content' },
        { id: 6, name: 'Delete' },
      ],
      selectedAction: null,
      screenSize: currentScreenSize,
      channels: [],
      pagination: {},
      loading: false,
      options: {},
      search: '',
      searchParams: '',
      confirmDelete: 'Are you sure you wish to delete this playlist',
      locations: [],
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options) + this.searchParams;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getChannels();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
    this.getCompanySites();
    // Add event listener for screen size changes
    this.handleResize();

    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    getActionList(item) {
      return [
        { name: 'Edit', action: () => this.showEditPanel(item.id) },
        {
          name: 'Enrol',
          action: () => this.showEnrolPanel(item.id),
        },
        {
          name: 'Unenroll',
          action: () => this.showUnEnrolPanel(item.id),
        },
        {
          name: 'Courses',
          action: () => this.showModulesPanel(item.id),
        },
        {
          name: 'Content',
          action: () => this.showSuppMaterialsPanel(item.id),
        },
        {
          name: 'Delete',
          action: () => this.deleteChannel(item.id),
        },
      ];
    },
    performAction(item) {
      const selectedOption = this.getActionList(item).find(
        (option) => option.name === this.selectedAction
      );
      if (selectedOption) {
        selectedOption.action();
      }
      setTimeout(() => {
        this.selectedAction = null;
      }, 0);
    },

    handleResize() {
      this.screenSize = getCurrentScreenSize();
    },

    resetSearch() {
      this.options.page = 1;
      this.searchParams = '';
      this.getChannels();
    },
    applySearch() {
      this.options.page = 1;
      if (this.search != null) {
        this.searchParams = this.params + '&search=name:' + this.search;
      } else {
        this.searchParams = this.params;
      }
      this.getChannels();
    },
    deleteChannel(id) {
      this.$snotify.confirm(this.confirmDelete, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processDeleteChannel(toast, id),
          },
        ],
      });
    },
    processDeleteChannel(toast, id) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      channelAPI.removeChannel(id).then((resp) => {
        this.getChannels();
        this.loading = false;
      });
    },
    getChannels() {
      this.loading = true;
      channelAPI.getChannels(this.params).then((resp) => {
        this.loading = false;
        this.channels = resp.data.data;
        this.pagination = resp.data.meta.pagination;
      });
    },
    setEventBus() {
      EventBus.$on('CHANNELS_UPDATED', (payload) => {
        //this.params = payload;
        this.getChannels();
      });
    },
    showCreatePanel() {
      this.$showPanel({
        component: CreateChannel,
        props: {
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditChannel,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showEnrolPanel(id) {
      this.$showPanel({
        component: EnrolUsers,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
          locations:this.locations,
        },
        openOn: 'right',
      });
    },
    showUnEnrolPanel(id) {
      this.$showPanel({
        component: UnEnrolUsers,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
          locations:this.locations,
        },
        openOn: 'right',
      });
    },
    showContentPanel(id) {
      this.$showPanel({
        component: ChannelContent,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showSuppMaterialsPanel(id) {
      this.$showPanel({
        component: SuppMaterials,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showModulesPanel(id) {
      this.$showPanel({
        component: Modules,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    getCompanySites() {
      companyAPI.getCompanySites().then(response => {
        this.locations = response.data.data;
      });
    },
  },
  beforeDestroy() {
    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.handleResize);

    this.screenSize = null;
  },
};
</script>
